import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { updatePayrollTaxBandURL } from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const EditTaxBands = ({ open, handleClose, updateTaxBands, taxes }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const initState = {
    first_band: "",
    first_band_rate: "",
    second_band: "",
    second_band_rate: "",
    third_band: "",
    third_band_rate: "",
    fourth_band: "",
    fourth_band_rate: "",
    fifth_band: "",
    fifth_band_rate: "",
    sixth_band: "",
    sixth_band_rate: "",
  };
  const [formData, setFormData] = useState(initState);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFormData({
      ...formData,
      first_band: taxes?.first_band,
      first_band_rate: taxes?.first_band_rate,
      second_band: taxes?.second_band,
      second_band_rate: taxes?.second_band_rate,
      third_band: taxes?.third_band,
      third_band_rate: taxes?.third_band_rate,
      fourth_band: taxes?.fourth_band,
      fourth_band_rate: taxes?.fourth_band_rate,
      fifth_band: taxes?.fifth_band,
      fifth_band_rate: taxes?.fifth_band_rate,
      sixth_band: taxes?.sixth_band,
      sixth_band_rate: taxes?.sixth_band_rate,
    });
    // eslint-disable-next-line
  }, [taxes]);

  const updatePayrollTaxBands = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
      ...formData,
    };
    await axios
      .post(updatePayrollTaxBandURL, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          handleClose();
          updateTaxBands();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className="Name">Edit Payroll Tax Bands</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">First Tax Band</label>
              <input
                name="first_band"
                value={formData.first_band}
                onChange={(e) =>
                  setFormData({ ...formData, first_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="first_band_rate"
                value={formData.first_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, first_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Second Tax Band</label>
              <input
                name="second_band"
                value={formData.second_band}
                onChange={(e) =>
                  setFormData({ ...formData, second_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="second_band_rate"
                value={formData.second_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, second_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Third Tax Band</label>
              <input
                name="third_band"
                value={formData.third_band}
                onChange={(e) =>
                  setFormData({ ...formData, third_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="third_band_rate"
                value={formData.third_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, third_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Fourth Tax Band</label>
              <input
                name="fourth_band"
                value={formData.fourth_band}
                onChange={(e) =>
                  setFormData({ ...formData, fourth_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="fourth_band_rate"
                value={formData.fourth_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, fourth_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Fifth Tax Band</label>
              <input
                name="fifth_band"
                value={formData.fifth_band}
                onChange={(e) =>
                  setFormData({ ...formData, fifth_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="fifth_band_rate"
                value={formData.fifth_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, fifth_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Sixth Tax Band</label>
              <input
                name="sixth_band"
                value={formData.sixth_band}
                onChange={(e) =>
                  setFormData({ ...formData, sixth_band: e.target.value })
                }
                type="text"
              />
            </div>
            <div className="Box">
              <label htmlFor="">Band Rate</label>
              <input
                name="sixth_band_rate"
                value={formData.sixth_band_rate}
                onChange={(e) =>
                  setFormData({ ...formData, sixth_band_rate: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            onClick={updatePayrollTaxBands}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Update"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default EditTaxBands;
